/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';
import styled, { useTheme } from 'styled-components';

import type {
  DropdownIndicatorProps,
  GroupBase,
} from 'react-select';

import { StyledControl } from './Control';

import type {
  ReactSelectExtendedProps,
} from '../ReactSelectExtended';
import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.button<{
  $small?: boolean;
  $isFocused?: boolean;
}>`
  display: flex;
  box-sizing: border-box;
  padding-top: ${({ $small }): number => ($small ? 3 : 8)}px;
  padding-bottom: ${({ $small }): number => ($small ? 3 : 8)}px;
  padding-right: 7px;
  transition: color 150ms ease 0s;
  color: ${({
    $isFocused,

    theme: {
      colors,
      select,
    },
  }): string => ($isFocused
    ? colors[select.ARROW_DOWN_COLOR_FOCUSED]
    : colors[select.ARROW_DOWN_COLOR]
  )};
  width: 28px;

  background: transparent;
  border: 0;
  cursor: pointer;

  &:hover, ${StyledControl}:hover & {
    color: ${({ theme: { select, colors } }) => colors[select.ARROW_DOWN_COLOR_HOVER]};
  }

  &:active {
    color: ${({ theme: { select, colors } }) => colors[select.ARROW_DOWN_COLOR_ACTIVE]};
  }
`;

export function DropdownIndicator<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>({
  innerProps,
  isFocused,
  selectProps,
  className,
}: DropdownIndicatorProps<OptionType, IsMulti, Group>): ReactElement {
  const {
    isArrowHidden,
    small,
  } = selectProps as ReactSelectExtendedProps<OptionType, IsMulti, Group>;

  const { select } = useTheme();

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Wrapper
      {...innerProps as any}
      className={className}
      $small={small}
      $isFocused={isFocused}
      data-n3__select-dropdown-indicator=""
      onClick={handleClick}
    >
      {
        isArrowHidden ? null : select.ARROW_DOWN_ICON
      }
    </Wrapper>
  );
}
